
export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/services", label: "Services" },
  { href: "/projects", label: "Projects" },
  { href: "/careers", label: "Careers" },
  { href: "/about", label: "About Us" },
  { href: "/contact", label: "Contact Us" },
];

export const contactInfo = {
  address: "Shraddhapuri Phase II, Kankerkhera, Meerut, Uttar Pradesh, India. 250001.",
  email: "info@darshnisoftware.com",
  phone: "+91 7248161647",
};

export const legalLinks = [
    { href: "/privacy-policy", label: "Privacy Policy" },
    { href: "/terms-of-service", label: "Terms of Service" },
    { href: "/cookie-policy", label: "Cookie Policy" },
];

export const socialLinks = {
    linkedin: "https://www.linkedin.com/company/darshni-software",
    x: "https://x.com/DarshniSoftware",
    facebook: "https://www.facebook.com/darshni.software",
    youtube: "https://www.youtube.com/@DarshniSoftware"
};
